module.exports = "/_next/static/images/ProcessingDeduplication@2x-78737f68f43a886ae2d6c7465d2e9f2a.webp";